export enum Status {
  PENDING = 'pending',
  APPROVED = 'approved',
  DENIED = 'denied',
  ARCHIVED = 'archived'
}
